import { Document } from "@contentful/rich-text-types";
import { useTheme } from "@emotion/react";
import React from "react";
import { InlineRichText } from "../../components/RichText";
import { AppTheme } from "../../utils/theme";
import CategoryIcon from "../CategoryIcon";
import Pip from "../Pip";
import { NavigateNextIcon } from "myplan/components/Icon";
import {
	ArrowContainer,
	Aside,
	Caption,
	Container,
	Main,
	Title,
} from "./styles";

type CategoryListItemProps = {
	item: CategoryItem;
	icon?: string;
	count: number;
	singular: string;
	plural: string;
	payload?: any;
	hasNew?: boolean;
	onPress?: (itemId: string) => void;
};

interface CategoryItem {
	_id: string;
	title: string;
	category: Document;
}

const CategoryListItem = ({
	item,
	icon,
	onPress,
	count,
	singular,
	plural,
	hasNew = true,
}: CategoryListItemProps) => {
	const {
		color: { enabled },
	}: AppTheme = useTheme() as AppTheme;
	const title = item.category ? (
		<InlineRichText doc={item.category} />
	) : (
		item.title
	);
	return (
		<Container onPress={() => onPress?.(item._id)}>
			<Aside>
				<CategoryIcon icon={icon} />
			</Aside>
			<Main>
				<Title type="mono1">{title}</Title>
				<Caption type="body3" allowFontScaling={false}>
					{count} {count > 1 ? plural : singular} <Pip on={hasNew} />
				</Caption>
			</Main>
			<ArrowContainer>
				<NavigateNextIcon color={enabled} width="20" height="20" />
			</ArrowContainer>
		</Container>
	);
};

export default CategoryListItem;
